export default "__VITE_ASSET__DsjjCXAX__"